import { render } from "./DefaultDataTable.vue?vue&type=template&id=3ccbf662"
import script from "./DefaultDataTable.vue?vue&type=script&lang=js"
export * from "./DefaultDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__